import React from 'react';
import BtnNavBack from '../../../cmp/nav/BtnNavBack';
import useAppCtx from '../../../../app/ctx-provider/useAppCtx';
import StvPage from '../../../../app/ctx-provider/StvPage';

const BtnHompage: React.FC = () => {
    const { appCtxBo, setAppCtxBo } = useAppCtx();

    const onClickHomepage = () => {        
        appCtxBo.currentPage = appCtxBo.abTestVersion === 'a' ? StvPage.HOMEPAGE : StvPage.HOMEPAGE_FACELIFT;
        setAppCtxBo(appCtxBo);
    }

    return <BtnNavBack onClick={onClickHomepage} />;

}

export default BtnHompage;